import Drawer from 'antd/es/drawer';
import styled from 'styled-components';

export const SearchMonthListWrapper = styled.div<{
  inputComponent?: 'shopAndFly' | 'setur';
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 16px 16px 25px 16px;
  box-shadow: 0px 10px 30px rgba(58, 58, 58, 0.2);
  color: ${({ inputComponent }) =>
    inputComponent === 'shopAndFly' ? '#000' : 'inherit'};
`;

export const SearchPopoverWrapper = styled.div`
  & .react-tiny-popover-container {
    width: 100% !important;
    max-width: 570px !important;
    top: -10px !important;
  }
`;

export const ToggleYearButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: fit-content;
  margin: 0 auto;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

export const ToggleYearButton = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 8px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};
  background-color: ${({ selected, theme }) =>
    selected ? theme.palette.darkGrey : theme.palette.white};
  color: ${({ selected, theme }) =>
    selected ? theme.palette.white : theme.palette.darkGrey};
  border: 1px solid
    ${({ selected, theme }) =>
      selected ? theme.palette.darkGrey : theme.palette.iron};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    display: inline-block;
    text-align: center;
    padding: 7px 8px;
  }
`;

export const YearTabWrapper = styled.div`
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-rows: 280px 60px;
    justify-content: center;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    justify-content: start;
  }
`;
export const YearMonthsItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-top: 20px;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 5px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: grid;
    grid-template-columns: repeat(3, 100px);
    grid-template-rows: repeat(3, 60px);
    gap: 0 20px;
    justify-content: center;
    justify-items: start;
  }
`;

export const YearMonthItem = styled.div`
  width: 119px;
  padding: 9px 10px;

  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.lynxWhite};
  margin-bottom: 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100px;
    padding: 9px 5px;
  }
`;

export const MobileDrawerItemWrapper = styled.div<{
  inputComponent?: 'shopAndFly' | 'setur';
}>`
  width: ${({ inputComponent }) =>
    inputComponent === 'shopAndFly' ? 'auto' : '100%'};
  background-color: ${({ theme }) => theme.palette.white};
`;

export const MobileSearchDrawer = styled(Drawer)`
  &&& {
    & .setur-drawer-title {
      flex: initial !important;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 700;
      font-size: 16px;
    }

    .setur-drawer-body {
      padding: 24px 15px;
    }
  }
`;

export const MobileSearchDrawerContent = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr 72px;
`;

export const MobileApplyButton = styled.button`
  width: 100%;
  padding: 11px 24px;
  background-color: ${({ theme }) => theme.palette.primaryBrand};
  display: inline-block;
  text-align: center;
  color: ${({ theme }) => theme.palette.white};
  font-weight: 700;
  font-size: 14px;
  border: none;
  height: fit-content;
  margin-top: auto;
`;
